module.exports = "/pages/business/foodslabo/charm_image_3.jpg";